import { Box, Paper, styled } from "@mui/material";

export const MPWrapper = styled(Box)({
    backgroundColor: "#F8F9FA"
})

export const UPMain = styled(Box)({
    // display: "flex",
    // flexDirection: "row",
    // border: "1px solid red",
    height: "90vh",
})
export const UPLeft = styled(Paper)({
})
export const UPRight = styled(Paper)({
})

export const UPPaper = styled(Paper)({
    // margin: "0px 20px 0px 20px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    border: "4px 4px 4px 4px",
})